var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.listImg),function(item,index){return _c('div',{key:index,staticClass:"imgDiv"},[_c('img',{attrs:{"src":item.src,"alt":""}}),_c('div',[_vm._v(_vm._s(item.alt))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }